<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="zeroStateRows"
      styleClass="vgt-table striped"
      row-style-class="blur-row"
      style="width: 100%;"
    >
      <template slot="table-row" slot-scope="zeroStateRows">
        <span v-if="zeroStateRows.column.field === 'image'">
          <img :src="zeroStateRows.row.image" class="product-icon" />
        </span>
        <template v-else-if="zeroStateRows.column.field === 'adminOnly'">
          <label class="checkbox-container">
            <input type="checkbox" disabled />
            <span class="checkmark top"></span>
          </label>
        </template>
      </template>

      <div class="vgt-center-align vgt-text-disabled" slot="emptystate">
        There are no items to display
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'StoreInventoryZeroState',
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Product',
          field: 'image'
        },
        {
          label: 'Product title',
          field: 'title'
        },
        {
          label: 'Category',
          field: 'category'
        },
        {
          label: 'Item Cost',
          field: 'cost'
        },
        {
          label: 'Admin Only',
          field: 'adminOnly'
        }
      ],
      zeroStateRows: []
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin: 3rem;
}

.product-icon {
  height: 45px;
}

.top {
  top: -5px !important;
}

.vgt-text-disabled {
  color: #24292c;
  padding: 10px;
}
</style>
